// Vendor libraries
import { lastValueFrom } from 'rxjs';
// Utils
import { formFlattenedParamString } from 'NewAngular/utils/urls';
/**
 * Builds a redirect URL for a list page by serializing user preferences as query params.
 * Preferences stored under `preferenceKey` are used as the base state, with `overrides` merged on top.
 * Falls back to `baseUrl` if user preferences cannot be fetched.
 *
 * @param accountsService - Service used to fetch user preferences
 * @param baseUrl - The list page base URL
 * @param preferenceKey - The user preference key containing the default list page state
 * @param stateKeys - The state keys to serialize into the query string
 * @param overrides - Optional state values to merge on top of user preferences
 */
export async function getListPageRedirectUrl(accountsService, baseUrl, preferenceKey, stateKeys, overrides) {
    try {
        const userPreferences = (await lastValueFrom(accountsService.getUserPreferences()));
        const params = { ...userPreferences[preferenceKey], ...overrides };
        return `${baseUrl}#/?${formFlattenedParamString(params, stateKeys)}`;
    }
    catch {
        return baseUrl;
    }
}
